import topic from '../topic'
export const mdrpAPI = {
    getMdrps: topic.mdrpTopic + '/get_mdrps',
}